import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const authContext = useContext(AuthContext);

  if (!authContext || authContext.loading) {
    return <div>Loading...</div>;
  }
  const { isAuthenticated } = authContext;

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  } else return children;
};
export default ProtectedRoute;
